import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * Small dismissable banner shown across all authenticated pages to remind
 * users that the application is currently in beta. State persisted in
 * localStorage so a single dismissal lasts for the session.
 */
export const BetaBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('beta_banner_dismissed');
    setVisible(!dismissed);
  }, []);

  if (!visible) return null;

  const handleDismiss = () => {
    localStorage.setItem('beta_banner_dismissed', '1');
    setVisible(false);
  };

  return (
    <div
      className="w-full bg-amber-50 border-b border-amber-200 text-amber-900 text-xs sm:text-sm"
      data-testid="beta-banner"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="flex-1 leading-snug">
          <strong className="font-semibold">Versione BETA</strong> — l&apos;applicazione è in fase di test.
          Per segnalare problemi scrivi a <a href="mailto:info@bollettinox.ch" className="underline">info@bollettinox.ch</a>.
        </span>
        <button
          type="button"
          onClick={handleDismiss}
          className="p-1 -mr-1 hover:bg-amber-100 rounded transition"
          aria-label="Chiudi"
          data-testid="beta-banner-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default BetaBanner;
